import { BaseError } from "./base-error.js";
export class ServiceProviderError extends BaseError {
    static code = 'ServiceProviderError';
    static statusCode = 500;
    constructor(message = 'Bad service provider', options = {}) {
        super(message, options);
    }
}
